// extracted by mini-css-extract-plugin
export default {"root":"customInput_root__NnZv7","fieldLabel":"customInput_fieldLabel__o-rPa","errorMessage":"customInput_errorMessage__9EX25","textInput":"customInput_textInput__xybbe"};